import styled from 'styled-components';

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  color: ${({ theme }) => theme.colors.white};
`;

export const SectionTitle = styled.div<{ $align?: 'flex-start' | 'flex-end' }>`
  align-self: ${({ $align }) => $align || 'flex-start'};
  font-weight: 700;
  font-size: 16px;
  line-height: 14px;
`;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Row = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 15px;
  border-bottom: 1px dashed #dfdfda;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.white};

  &:last-child {
    border-bottom: none;
  }
`;

export const RowLabel = styled.span`
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.white};
`;
